import { render, staticRenderFns } from "./MoleculeImageSliderWithThumbnails.vue?vue&type=template&id=4ef45586&"
import script from "./MoleculeImageSliderWithThumbnails.vue?vue&type=script&lang=js&"
export * from "./MoleculeImageSliderWithThumbnails.vue?vue&type=script&lang=js&"
import style0 from "./MoleculeImageSliderWithThumbnails.vue?vue&type=style&index=0&id=4ef45586&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AtomsCommonSliderAtomImageSlider: require('/app/components/atoms/common/slider/AtomImageSlider.vue').default,AtomsCommonSliderAtomImageThumbSlider: require('/app/components/atoms/common/slider/AtomImageThumbSlider.vue').default})
